import React, { useContext, useState } from 'react';
import { Form } from '@brynlabs/webforms-js';
import { set } from 'lodash';
import { v4 } from 'uuid';
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

/* global Reflect, Promise */

var _extendStatics = function extendStatics(d, b) {
  _extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } || function (d, b) {
    for (var p in b) {
      if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    }
  };

  return _extendStatics(d, b);
};

function __extends(d, b) {
  if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");

  _extendStatics(d, b);

  function __() {
    this.constructor = d;
  }

  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var _assign = function __assign() {
  _assign = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return _assign.apply(this, arguments);
};

function __rest(s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
}

function __awaiter(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}

function __generator(thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
}

var WebformFormContext =
/** @class */
function () {
  function WebformFormContext() {
    this.onErrors = {};
    this.onUpdates = {};
    this.formToken = '';
    this.data = {};
    this.defaultSet = {};
    this.errors = [];
    this.loading = false;
    this.success = false;
    this.failed = false;
  }
  /**
   * This method resets the context if the formToken has changed.
   * @param formToken
   */


  WebformFormContext.prototype.resetIfChanged = function (formToken) {
    if (formToken !== this.formToken) {
      this.formToken = formToken;
      this.onErrors = {};
      this.onUpdates = {};
      this.data = {};
      this.errors = [];
      this.loading = false;
      this.success = false;
      this.failed = false;
    }
  };

  WebformFormContext.prototype.onError = function (cb, field, uid) {
    if (!this.onErrors[field]) {
      this.onErrors[field] = [];
    }

    var index = this.onErrors[field].findIndex(function (d) {
      return d.uid === uid;
    });

    if (index === -1) {
      this.onErrors[field].push({
        cb: cb,
        uid: uid
      });
    } else {
      this.onErrors[field][index].cb = cb;
    }
  };

  WebformFormContext.prototype.onUpdate = function (cb, field, uid) {
    if (!this.onUpdates[field]) {
      this.onUpdates[field] = [];
    }

    var index = this.onUpdates[field].findIndex(function (d) {
      return d.uid === uid;
    });

    if (index === -1) {
      this.onUpdates[field].push({
        cb: cb,
        uid: uid
      });
    } else {
      this.onUpdates[field][index].cb = cb;
    }
  };

  WebformFormContext.prototype.setData = function (data, field, uid, dontUpdateUid) {
    if (dontUpdateUid === void 0) {
      dontUpdateUid = false;
    }

    set(this.data, field, data);

    for (var _i = 0, _a = this.onErrors[field] || []; _i < _a.length; _i++) {
      var cb = _a[_i].cb;
      cb('');
    }

    for (var _b = 0, _c = this.onUpdates[field] || []; _b < _c.length; _b++) {
      var update = _c[_b];

      if (!dontUpdateUid || update.uid !== uid) {
        update.cb(data);
      }
    }
  };

  WebformFormContext.prototype._setErrors = function (errors) {
    this.errors = errors;

    for (var _i = 0, errors_1 = errors; _i < errors_1.length; _i++) {
      var _a = errors_1[_i],
          path = _a.path,
          localizedMessage = _a.localizedMessage;
      var cbs = this.onErrors[path] || [];

      for (var _b = 0, cbs_1 = cbs; _b < cbs_1.length; _b++) {
        var cb = cbs_1[_b].cb;
        cb(localizedMessage);
      }

      if (cbs.length === 0) {
        console.error('An unhandled webforms validation error occurred. Please consider including something like <ErrorMessage webformsKey={"' + path + '"}/>');
      }
    }
  };

  WebformFormContext.prototype.setDefaultValue = function (defaultValue, field) {
    if (!this.defaultSet[field]) {
      this.defaultSet[field] = true;
      set(this.data, field, defaultValue);
    }
  };

  return WebformFormContext;
}();

var FormContext = React.createContext(new WebformFormContext());

var WebformComponent =
/** @class */
function (_super) {
  __extends(WebformComponent, _super);

  function WebformComponent(props, context) {
    var _this = _super.call(this, props, context) || this;

    _this.webformsContext = new WebformFormContext();
    var formToken = props.formToken,
        _a = props.recaptchaPublicKey,
        recaptchaPublicKey = _a === void 0 ? '' : _a,
        webformsEndpoint = props.webformsEndpoint;

    _this.onSuccess = props.onSuccess || function () {};

    _this.onSubmit = props.onSubmit || function (data) {};

    _this.onError = props.onError || function (error) {};

    _this.form = new Form(formToken, recaptchaPublicKey);

    if (webformsEndpoint) {
      _this.form.setWebformsEndpoint(webformsEndpoint);
    }

    _this.state = {
      data: {}
    };
    return _this;
  }

  WebformComponent.prototype.componentDidMount = function () {};

  WebformComponent.prototype.handleSubmit = function (ev) {
    return __awaiter(this, void 0, void 0, function () {
      var res, e_1;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            ev.preventDefault();
            this.onSubmit(this.webformsContext.data);
            this.webformsContext.loading = true;
            _a.label = 1;

          case 1:
            _a.trys.push([1, 3,, 4]);

            return [4
            /*yield*/
            , this.form.submit(this.webformsContext.data)];

          case 2:
            res = _a.sent();
            return [3
            /*break*/
            , 4];

          case 3:
            e_1 = _a.sent();
            this.onError(e_1);
            this.webformsContext.loading = false;
            return [2
            /*return*/
            ];

          case 4:
            this.webformsContext.loading = false;
            this.webformsContext.failed = res.failed;
            this.webformsContext.success = !res.failed;

            if (res.failed) {
              this.webformsContext._setErrors(res.validationErrors);

              this.onError(res);
            } else {
              this.onSuccess();
            }

            return [2
            /*return*/
            ];
        }
      });
    });
  };

  WebformComponent.prototype.render = function () {
    var _this = this;

    return React.createElement(FormContext.Provider, {
      value: this.webformsContext
    }, React.createElement("form", {
      onSubmit: function onSubmit(ev) {
        return _this.handleSubmit(ev);
      }
    }, this.props.children, React.createElement("noscript", null, React.createElement("a", {
      href: "https://webforms.brynlabs.com/form/" + this.props.formToken
    }, "Click here to open this form."))));
  };

  return WebformComponent;
}(React.Component);

var withFormContext = function withFormContext(WrappedComponent) {
  return function (props) {
    var context = useContext(FormContext);
    return React.createElement(WrappedComponent, _assign({}, props, {
      context: context
    }));
  };
};

var _withFormElement = function _withFormElement(WrappedComponent, _a) {
  var _b = _a === void 0 ? {} : _a,
      defaultValue = _b.defaultValue;

  return (
    /** @class */
    function (_super) {
      __extends(class_1, _super);

      function class_1(props) {
        var _this = _super.call(this, props) || this;

        _this.uid = v4();
        var context = props.context,
            webformsKey = props.webformsKey,
            onChange = props.onChange;
        context.setDefaultValue(defaultValue, webformsKey);
        context.onUpdate(function (value) {
          return _this.setState({
            value: value
          });
        }, webformsKey, _this.uid);

        if (onChange) {
          context.onUpdate(onChange, webformsKey, 'ext_' + _this.uid);
        } // @ts-ignore


        _this.state = {
          value: context.data[webformsKey]
        };
        return _this;
      }

      class_1.prototype.componentDidMount = function () {
        var _a = this.props,
            context = _a.context,
            webformsKey = _a.webformsKey,
            value = _a.value;

        if (this.props.hasOwnProperty('value') && value !== this.state.value) {
          context.setData(value, webformsKey, this.uid);
        }
      };

      class_1.prototype.componentDidUpdate = function (prevProps, prevState, snapshot) {
        var _a = this.props,
            context = _a.context,
            webformsKey = _a.webformsKey,
            value = _a.value;

        if (this.props.hasOwnProperty('value') && this.props['value'] !== prevProps.value && this.props['value'] !== this.state.value) {
          context.setData(value, webformsKey, this.uid);
        }
      };

      class_1.prototype.render = function () {
        var _this = this;

        var _a = this.props,
            context = _a.context,
            webformsKey = _a.webformsKey;
        _a.onChange;
        _a.value;

        var props = __rest(_a, ["context", "webformsKey", "onChange", "value"]);

        return React.createElement(WrappedComponent, _assign({}, props, {
          key: this.uid,
          data: this.state.value,
          setData: function setData(d) {
            return context.setData(d, webformsKey, _this.uid);
          },
          onError: function onError(fn) {
            return context.onError(fn, webformsKey, _this.uid);
          }
        }));
      };

      return class_1;
    }(React.Component)
  );
};

var withFormElement = function withFormElement(WrappedComponent, conf) {
  return withFormContext(_withFormElement(WrappedComponent, conf));
};

var _Input = withFormElement(function (_a) {
  var data = _a.data,
      setData = _a.setData,
      props = __rest(_a, ["data", "setData"]);

  return React.createElement("input", _assign({}, props, {
    value: data,
    onChange: function onChange(ev) {
      return setData(ev.target.value);
    }
  }));
}, {
  defaultValue: ''
});

var _Checkbox = withFormElement(function (_a) {
  var data = _a.data,
      setData = _a.setData,
      props = __rest(_a, ["data", "setData"]);

  return React.createElement("input", _assign({}, props, {
    type: 'checkbox',
    checked: data,
    onChange: function onChange(ev) {
      return setData(ev.target.checked);
    }
  }));
}, {
  defaultValue: false
});

var Input = function Input(_a) {
  var _b = _a.type,
      type = _b === void 0 ? 'text' : _b,
      props = __rest(_a, ["type"]);

  if (type.toLowerCase() === 'checkbox') {
    return React.createElement(_Checkbox, _assign({}, props));
  }

  return React.createElement(_Input, _assign({
    type: type
  }, props));
};

var Select = withFormElement(function (_a) {
  var data = _a.data,
      setData = _a.setData,
      children = _a.children,
      props = __rest(_a, ["data", "setData", "children"]);

  return React.createElement("select", _assign({}, props, {
    value: data,
    onChange: function onChange(ev) {
      return setData(ev.target.value);
    }
  }), children);
}, {
  defaultValue: ''
});
var Textarea = withFormElement(function (_a) {
  var data = _a.data,
      setData = _a.setData,
      props = __rest(_a, ["data", "setData"]);

  return React.createElement("textarea", _assign({}, props, {
    value: data,
    onChange: function onChange(ev) {
      return setData(ev.target.value);
    }
  }));
}, {
  defaultValue: ''
});
var ErrorMessage = withFormElement(function (_a) {
  var onError = _a.onError,
      children = _a.children;
  _a.setData;
  _a.getData;

  var props = __rest(_a, ["onError", "children", "setData", "getData"]);

  var _b = useState(''),
      errorMessage = _b[0],
      setErrorMessage = _b[1];

  onError(setErrorMessage);
  return React.createElement("span", _assign({}, props), errorMessage !== '' && (children || errorMessage));
});
export { ErrorMessage, Input, Select, Textarea, WebformComponent, withFormElement };